import React from "react";
import Grid from "@material-ui/core/Grid";
import PrimaryButton from "../../../../../components/Buttons/PrimaryButton";
import {SERVICE_CONCEPTS, TRANSACTION_TYPE_VALUES} from "../../../constants";
import PortfolioBuilder
  from '../../../../RiskProfiling/components/StepContent/components/step/ProductsSelectionSteps/components/InvestmentRecommendationStep/components/PortfolioBuilder';
import usePortfolioBuilder from "./PortfolioTradeV2/hooks/usePortfolioBuilder";
import {getPortfolioInstruments} from "./tradingOperations";
import CompareIcon from "../../../../../images/CompareIcon";
import {FUNCTION_NOT_AVAILABLE_MSG} from "../constants";


/**
 * Checks if Portfolio-Builder is available for the current user/configuration.
 */
export const getPortfolioBuilderAvailability = (portfolio, dataService) => {
  if (!portfolio.portfolioBuilderAvailable || portfolio.isModelportfolio || portfolio.isETF){
    return {
      available: false,
      tooltip: FUNCTION_NOT_AVAILABLE_MSG
    }
  }

  const isAnlageberatung = dataService.serviceConcept == SERVICE_CONCEPTS.Anlageberatung;

  if (!isAnlageberatung) {
    return {
      available: false,
      tooltip: 'Um den Portfolio-Builder nutzen zu können, muss eine Anlageberatung durchgeführt werden. Anlagevermittlung oder Execution-Only sind nicht möglich.',
    };
  }

  if (!dataService.hasInvestmentFundsKnowledge(dataService.serviceConcept)) {
    return {
      available: false,
      tooltip: 'Um den Portfolio-Builder nutzen zu können, muss der Kunden auf der Seite "Kenntnisse & Erfahrungen" Kenntnisse in "Offene Investmentfonds" vorweisen.',
    };
  }

  return {
    available: true,
    tooltip: 'Portfolio-Builder starten um Kauf-/Verkaufsempfehlungen zu erhalten',
  };
};


const PortfolioBuilderFeature = ({
  portfolio,
  dataService,
  isVirtual,
  handlePortfolioChange,
  allowedTradeOptions,
}) => {
  const {available, tooltip} = getPortfolioBuilderAvailability(portfolio, dataService);

  const shouldAutoOpen = portfolio && portfolio.autoPortfolioBuilder && available;
  if (shouldAutoOpen) {
    delete portfolio.autoPortfolioBuilder;
  }

  const pb = usePortfolioBuilder({
    portfolio, dataService, isVirtual, handlePortfolioChange, allowedTradeOptions,
    initialActive: shouldAutoOpen,
  });

  return (
    <>
      <Grid item>
        <PrimaryButton
          variant="text"
          icon={<CompareIcon color={!available && 'rgba(0, 0, 0, 0.26)'} />}
          text="Portfolio-Builder"
          tooltip={tooltip}
          disabled={!available}
          onButtonClick={pb.open}
          dataId={'portfolio-builder-btn'}
        />
      </Grid>

      {pb.active && portfolio && (
        <Grid item xs={12} data-id={'portfolio-builder-container'}>
          <PortfolioBuilder
            dataService={{
              session_id: `${dataService.session_id}-${portfolio.data.id}`,
              getPortfolioBuilderInfo: async function () {
                const info = await dataService.getPortfolioBuilderInfo();
                return {
                  ...info,
                  holdings: getPortfolioInstruments(portfolio, portfolio.transactions, isVirtual, TRANSACTION_TYPE_VALUES.PORTFOLIO_BUILDER)
                };
              }
            }}
            caseData={pb.caseData}
            setCaseData={pb.setCaseData}
            setRecommendations={pb.setRecommendations}
            closeHandler={pb.close}
          />
        </Grid>
      )}
    </>
  );
};

export default PortfolioBuilderFeature;
